// docs: https://github.com/altostra/type-validations#readme
import { anyOf, enumOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

import type {
  PostwsAppsAppGroupIdUserImportsImportIdValidateResponse,
  PostwsAppsAppGroupIdUserImportsImportIdValidateResult,
} from "./types";

const isPostwsAppsAppGroupIdUserImportsImportIdValidateResultInner =
  objectOf<PostwsAppsAppGroupIdUserImportsImportIdValidateResult>({
    id: string,
    start_time: number,
    name: string,
    total_rows: number,
    import_count: number,
    malformed_count: number,
    no_id_count: number,
    is_done: boolean,
    segment_id: anyOf(string, nullOrUndefined),
    cancelled: boolean,
    download_link: anyOf(string, nullOrUndefined),
    error_report_download_link: anyOf(string, nullOrUndefined),
    has_error_report: boolean,
    is_uploaded_by_current_developer: boolean,
    validation_report_download_link: anyOf(string, nullOrUndefined),
    validation_started_at: anyOf(number, string, nullOrUndefined),
    validation_status: anyOf(
      enumOf("in_progress", "completed", "timed_out", "skipped", "cancelled"),
      nullOrUndefined
    ),
    validation_summary: objectOf({
      blocking_error_count: anyOf(number, nullOrUndefined),
      non_blocking_error_count: anyOf(number, nullOrUndefined),
      rows_checked: anyOf(number, nullOrUndefined),
    }),
    should_make_filterable: boolean,
    import_type: string,
    has_hit_user_limit: boolean,
    failed: boolean,
    developer: anyOf(string, nullOrUndefined),
  });

/** Pusher callback receives event.data = { results: <import> }. */
export const isPostwsAppsAppGroupIdUserImportsImportIdValidateResult =
  objectOf<PostwsAppsAppGroupIdUserImportsImportIdValidateResponse>({
    results: isPostwsAppsAppGroupIdUserImportsImportIdValidateResultInner,
  });
